module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("UcLeO"))).then(() => parcelRequire('ikE14'));